module.exports = __webpack_public_path__ + "img/campaign03.ae27887b.jpg";